<div class="p-10">
  <h2 class="text-3xl text-primary pb-12">Spindverwaltung</h2>
  <div class="container mx-auto p-4">
    <app-locker-list></app-locker-list>
  </div>
</div>
